import { gql } from '@apollo/client';

export const VIDEO_FRAGMENT = gql`
  fragment VideoFragment on Video {
    id
    url
    status
    created_at
    display_title
    downloaded
    avatar {
      id
      name
      description
      preview_image_url
      default_heygen_voice_id
      default_voice {
        id
      }
    }
    image_urls
    script
    thumbnail_url
    original_scraped_image_urls
    edit_attempts_used
  }
`;
